module.exports = __webpack_public_path__ + "img/newguide.4220fc44.png";